<div class="customer-tab-view">
  <!-- Left arrow positioned absolutely outside -->
  <div
    class="tab-arrow tab-arrow-left"
    (click)="scrollTabs('left')"
    [class.hidden]="!canScrollLeft"
  >
    <img
      src="assets/images/sidebar/chevron-left.svg"
      alt="Previous tabs"
      class="arrow-icon arrow-icon-left"
    />
  </div>

  <!-- Right arrow positioned absolutely outside -->
  <div
    class="tab-arrow tab-arrow-right"
    (click)="scrollTabs('right')"
    [class.hidden]="!canScrollRight"
  >
    <img
      src="assets/images/customer/chevron-right.svg"
      alt="Next tabs"
      class="arrow-icon arrow-icon-right"
    />
  </div>

  <!-- Tab Navigation -->
  <div class="tab-navigation">
    <!-- Tab list container with scrolling -->
    <div class="tab-list-container" #tabListContainer>
      <div class="tab-list" #tabList>
        <div
          *ngFor="let tab of tabs; trackBy: trackByIndex"
          class="tab-item"
          [class.active]="tab.active"
          (click)="onTabClick(tab.id)"
        >
          <div class="tab-content">
            <img class="tab-icon" [src]="tab.icon" [alt]="tab.label + ' icon'" />
            <span class="tab-label">{{ tab.label }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Tab Content -->
  <div class="tab-content-area">
    <!-- Customer Info Tab -->
    <app-customer-info-tab
      [style.display]="activeTabId === 'customer-info' ? 'block' : 'none'"
      [customer]="customer"
      (customerUpdated)="onCustomerUpdated()"
    >
    </app-customer-info-tab>

    <!-- Vehicles Tab -->
    <app-vehicles-list
      *ngIf="activeTabId === 'vehicles'"
      [customer]="customer"
      (vehiclesChanged)="onCustomerUpdated()"
    >
    </app-vehicles-list>

    <!-- Subscriptions Tab (CWS-1470) -->
    <app-customer-subscriptions-tab
      *ngIf="activeTabId === 'subscriptions'"
      [customerId]="customer?.id || ''"
      [customerName]="customerDisplayName"
      [customerPhone]="customer?.contact || ''"
      [subscriptions]="subscriptions"
      (subscriptionsChanged)="onSubscriptionsChanged($event)"
    >
    </app-customer-subscriptions-tab>

    <!-- Prepaid Tab (CWS-1833) -->
    <app-customer-prepaid-tab
      *ngIf="activeTabId === 'prepaid'"
      [customerId]="customer?.id || ''"
      [customerName]="customerDisplayName"
      [purchases]="prepaidPurchases"
      (purchasesChanged)="onPrepaidPurchasesChanged($event)"
      (openCustomer)="openCustomer.emit($event)"
    >
    </app-customer-prepaid-tab>

    <!-- Family Plan Tab -->
    <app-family-plan-tab
      *ngIf="activeTabId === 'family-plan'"
      [view]="familyView"
      (changed)="onFamilyPlanChanged()"
    >
    </app-family-plan-tab>

    <!-- Service History Tab -->
    <app-service-history
      *ngIf="activeTabId === 'service-history'"
      [customerId]="customer?.id || ''"
      (downloadInvoice)="onDownloadInvoice($event)"
      (printInvoice)="onPrintInvoice($event)"
    >
    </app-service-history>

    <!-- Appointments Tab -->
    <app-appointments *ngIf="activeTabId === 'appointments'" [customerId]="customer?.id || ''">
    </app-appointments>

    <!-- Reviews Tab -->
    <app-reviews *ngIf="activeTabId === 'reviews'"></app-reviews>

    <!-- Discounts Used Tab -->
    <app-discounts-used *ngIf="activeTabId === 'discounts-used'" [customerId]="customer?.id || ''">
    </app-discounts-used>
  </div>
</div>
